import { environmentHttpClient } from "../httpClient";

export function getEncryptionKey(encryptionPublic: string): Promise<string> {
	return environmentHttpClient.get<string>("FrontEndEncryption", { encryptionPublic });
}